export enum MenuSign {
    iniciarSesion = 'signIn',
    registrarse= 'signUp',
}